<mat-form-field class="input-search-dropdown-container w-100 relative"
                [ngClass]="inputClass"
                appearance="outline"
                [hideRequiredMarker]="true"
                floatLabel="always"
                [class.mat-form-field-invalid]="resultControl?.invalid && resultControl?.touched && !ItemsSelect.panelOpen"
                [class.mat-focused]="ItemsSelect.panelOpen"
                [class.mb-1]="resultControl?.invalid && resultControl?.touched"
                (click)="togglePanel($event)">
  <mat-label>
    <span class="color-navi">{{inputLabel}}</span><span *ngIf="isRequired" class="color-error">*</span>:
  </mat-label>
  <div class="relative">
    <input matInput [placeholder]="placeholder"
           type="text"
           [formControl]="inputCtrl"
           class="app-input"
           [required]="isRequired"
           [readonly]="true"
           [errorStateMatcher]="errorMatcher()"
           [attr.data-test-id]="'input_'+testId">
    <div *ngIf="ItemsSelect.openedChange && !inputCtrl.value" class="absolute arrow-down">
      <span class="icon icon-arrow-down"></span>
    </div>
    <button
      class="rst-button"
      [class.rst-button--disabled]="inputCtrl?.disabled"
      (click.stop-propagation)="clearInputValue()"
      mat-icon-button
      type="button"
      aria-label="Clear element"
      [attr.data-test-id]="'clear_button_'+testId"
      *ngIf="inputCtrl.value"
      [disabled]="inputCtrl?.disabled"
    >
      <mat-icon [inline]="true">close</mat-icon>
    </button>
  </div>
  <mat-select [formControl]="ItemsFormCtrl"
              [disableOptionCentering]="true"
              [disableRipple]="true"
              panelClass="input-search-dropdown-list w-100"
              (openedChange)="openedChange($event)"
              #ItemsSelect>
    <mat-option class="search-input" [ngClass]="{'loading': searching}">
      <ngx-mat-select-search class="input-search-dropdown-input"
                             [formControl]="ItemsFormFilterCtrl"
                             [searching]="searching" type="{{inputType}}"
                             noEntriesFoundLabel="{{'common.label.not-found' | translate}}"
                             placeholderLabel ="Search"></ngx-mat-select-search>
    </mat-option>
    <mat-option
      *ngFor="let item of filteredItemsList | async; index as itemIndex"
      [value]="item"
      [attr.data-test-id]="[testId, 'options', itemIndex] | join"
      [attr.data-test-text]="!itemLabel && itemLabelFn ? getOptionLabel(item) : itemLabel && !itemLabelFn ? item[itemLabel] : null"
    >
      <ng-container *ngIf="!highlights">
        <div *ngIf="!itemLabel && itemLabelFn">{{getOptionLabel(item)}}</div>
        <div *ngIf="itemLabel && !itemLabelFn">{{item[itemLabel]}}</div>
      </ng-container>
      <ng-container *ngIf="highlights">
        <div *ngIf="!itemLabel && itemLabelFn" [innerHTML]="highlighted(withExtras(getOptionLabel(item), item, ItemsFormFilterCtrl.value), ItemsFormFilterCtrl.value)"></div>
        <div *ngIf="itemLabel && !itemLabelFn" [innerHTML]="highlighted(withExtras(item[itemLabel], item, ItemsFormFilterCtrl.value), ItemsFormFilterCtrl.value)"></div>
      </ng-container>
    </mat-option>
  </mat-select>

  <mat-hint *ngIf="inputHint" class="hint">
    <span *ngIf="inputHintIcon" class="icon icon-info"></span> {{inputHint}}</mat-hint>

  <mat-error *ngIf="resultControl?.invalid && resultControl?.touched && !ItemsSelect.panelOpen">
    <span class="icon icon-error fs-md"></span> {{getErrorMessage()}}</mat-error>
</mat-form-field>
